import React, { useContext, useEffect, useState } from 'react';

const Blog = () => {
  return <div>Blog</div>;
};

export default Blog;
